<template>
  <div>
    <DxTabPanel      
      :data-source="tabs"
      :selected-index.sync="selectedIndex"
      :loop="loop"
      :animation-enabled="animationEnabled"
      :swipe-enabled="swipeEnabled"
    >
      <template #title="{ data: tabs }">  
        <span>{{ tabs.Caption }}</span>
      </template>

      <template #item="{  }">
        <div class="tabpanel-item">
          <!-- Change the component that is displayed, based on the selected tab -->
          <div v-if="selectedIndex == 0">
          <AdminHome></AdminHome>
          </div>
          <div v-else-if="selectedIndex == 1">
          <AdminEmailLog></AdminEmailLog>
          </div>
          <div v-else-if="selectedIndex == 2">
          <AdminLocations></AdminLocations>
          </div>
          <div v-else-if="selectedIndex == 3">
          <AdminSettings></AdminSettings>
          </div>
          <div v-else-if="selectedIndex == 4">
          <QR></QR>
          </div>

        </div>
      </template>
    </DxTabPanel>
    <!--<div class="item-box">
      Item <span>{{ selectedIndex + 1 }}</span> of <span>{{ companies.length }}</span>
    </div>-->
  </div>
</template>
<script>

import DxTabPanel from 'devextreme-vue/tab-panel';

import adminData from '../../src/data/admin-data.js';

import AdminHome from './admin/admin-home';
import AdminLocations from './admin/admin-locations.vue';
import AdminSettings from './admin/admin-settings';
import AdminEmailLog from './admin/admin-email-log';
import QR from './home';
import auth from "../auth";

export default {
  components: {
    DxTabPanel,
    AdminHome,
    AdminLocations,
    AdminSettings,
    AdminEmailLog,
    QR,
  },
  props: {
    selectedTabIndex: 0,
  },
  data() {
    return {
      selectedIndex: this.selectedTabIndex,
      loop: true,
      animationEnabled: true,
      swipeEnabled: false,
      tabs: adminData.getTabs(),
    };
  },
  created(){
    console.log('LocalStorage.dinesafeData: ' + localStorage.dinesafeData);

    if(localStorage.dinesafeData != null && localStorage.dinesafeData != '' || this.$store.state.user.isAdmin)
    {
      var accountInfo = JSON.parse(localStorage.dinesafeData);

      if(accountInfo.SubscriptionId != null)
      {
        auth.authenticated = true;
        this.$store.commit("setIsAdmin", true);
        
        //This updates the name of the logged in user in the top right
        this.$store.commit("setEmail", accountInfo.Email);
      }
      else{
        //route to the login-form
         this.$router.push("/login-form");
      }
    }
    else
    {
      //route to the login-form
      this.$router.push("/login-form");
    }
  },
  mouted(){
    console.log('LocalStorage.dinesafeData: ' + localStorage.dinesafeData);

    if(localStorage.dinesafeData != null && localStorage.dinesafeData != '' || this.$store.state.user.isAdmin)
    {
      var accountInfo = JSON.parse(localStorage.dinesafeData);

      if(accountInfo.SubscriptionId != null)
      {
        auth.authenticated = true;
        this.$store.commit("setIsAdmin", true);

        this.$store.commit("setCurrentAccountId", localStorage.dinesafeAccountId);
      }
      else{
        //route to the login-form
      }
    }
    else
    {
      //route to the login-form
    }
  },
};
</script>
<style>
.tabpanel-item {
    /*height: 200px;*/
    user-select: none;
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
}

/* This will set the width of the tab content to be size for a cell phone */
/*.mobile .tabpanel-item {
    padding-top: 10px;
}

.tabpanel-item  > div {
    float: left;
    padding: 0 40px 10px 10px
}*/

.tabpanel-item  p {
    font-size: 16px;
    margin: 0;
}

.item-box {
    font-size: 16px;
    margin: 15px 0 45px 10px;
}

.caption {
    font-size: 18px;
    font-weight: 500;
}
</style>